// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/confirmUnload/confirmUnload.js#1 $

/**
* @ngdoc directive
* @name tcApp.directive:tcConfirmUnload
* @description
* Form Unload confirmation when changing routes or closing window, if form is dirty
*/

angular.module('tc.confirmUnload', [])
.directive('tcConfirmUnload', function($window, $rootScope, $parse, $location, GlobalService, WorkflowService) {
	return {
		link: function($scope, element, attrs) {
			var tcConfirmUnload = $parse(attrs.tcConfirmUnload);
			
			var windowConfirmUnload = function(event) {
				if (tcConfirmUnload($scope)) {
					event.preventDefault();
					// Note that the custom message is not supported in Chrome
					//https://developers.google.com/web/updates/2016/04/
					//        chrome-51-deprecations?hl=en#remove_custom_messages_in_onbeforeunload_dialogs
					var unsavedMessage = GlobalService.getGlobalStrings().XUNSAVED;
					event.returnValue = unsavedMessage;
					return unsavedMessage;
				}
			};
			$window.addEventListener('beforeunload', windowConfirmUnload);
			
			// Called from WorkflowService $locationChangeStart listener
			var locationChangeStartUnbind = $rootScope.$on('Workflow:locationChangeStart',
				function locationChangeConfirmUnload(event, newUrl, newDialogLevel, currentDialogLevel) {
				if (WorkflowService.confirmUnloadPrompted) return;
				// Don't check dirty on session lock
				if (newUrl.search('websys.LockSession') !== -1) return;

				if (tcConfirmUnload($scope)) {
					// Don't alert on opening a new breadcrumb level
					// Still run 'isDirty' function so the dirty state is saved in the component cache
					if (newDialogLevel > currentDialogLevel) return;
					
					if (!$window.confirm(GlobalService.getGlobalStrings().XUNSAVED)) {
						WorkflowService.navigateAwayPrevented = true;
						event.preventDefault();
					}
					WorkflowService.confirmUnloadPrompted = true;
				}
			});
			
			var confirmUnloadForTabOrNested = function() {
				if (tcConfirmUnload($scope)) {
					return $window.confirm(GlobalService.getGlobalStrings().XUNSAVED);
				}
				return true;
			};
			// Emit events to be picked up if this component is in a tab control or is a nested component
			$scope.$emit('ConfirmUnload:tabControlBeforeSelect', $scope.componentHtmlName, confirmUnloadForTabOrNested);
			$scope.$emit('ConfirmUnload:nestedBeforeUnload', $scope.componentHtmlName, confirmUnloadForTabOrNested);

			$scope.$on('$destroy', function() {
				$window.removeEventListener('beforeunload', windowConfirmUnload);
				locationChangeStartUnbind();
			});
		}
	};
});
